const RowSpacing = ({ height = '20px' }) => {
    return <div style={{ height }}></div>;
};

export default RowSpacing;
